import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'on-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {
  @Input() message = '';

  constructor() { }

  ngOnInit() {
  }

}
